import { IMPRESSION_ACTIONS, SCREEN_NAME, CLICK_ACTIONS } from "@payment-client/analytics/constants";
import { AnalyticsContextValue } from "@swiggy-private/checkout-core";

export const upiTimerImpressionEvent = (impressionEvent: AnalyticsContextValue["impressionEvent"]): void => {
    impressionEvent({
        category: SCREEN_NAME.UPI_TIMER,
        action: IMPRESSION_ACTIONS.IMPRESSION_UPI_TIMER,
    });
};

export const upiTimerBackClickEvent = (clickEvent: AnalyticsContextValue["clickEvent"]): void => {
    clickEvent({
        category: SCREEN_NAME.UPI_TIMER,
        action: CLICK_ACTIONS.CLICK_UPI_TIMER_BACK,
    });
};

export const upiTimerCancelHalfCardCancelClickEvent = (clickEvent: AnalyticsContextValue["clickEvent"]): void => {
    clickEvent({
        category: SCREEN_NAME.UPI_TIMER,
        action: CLICK_ACTIONS.CLICK_UPI_TIMER_HALF_CARD_CANCEL,
    });
};

export const upiTimerCancelClickEvent = (clickEvent: AnalyticsContextValue["clickEvent"]): void => {
    clickEvent({
        category: SCREEN_NAME.UPI_TIMER,
        action: CLICK_ACTIONS.CLICK_UPI_TIMER_CANCEL,
    });
};

export const upiTimerCancelHalfCardImpressionEvent = (
    impressionEvent: AnalyticsContextValue["impressionEvent"],
): void => {
    impressionEvent({
        category: SCREEN_NAME.UPI_TIMER,
        action: IMPRESSION_ACTIONS.IMPRESSION_UPI_TIMER_CANCEL_HALF_CARD,
    });
};
